import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'rizzui';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FacilitatorScheduledCalls from './FacilitatorScheduledCalls';

const FacilitatorScheduledCallsWrapper = () => {
    const navigate = useNavigate();

    return (
        <Fragment>
            <PageHeader
                title="Agendados"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Agendados', href: menuRoutes.calls.path + menuRoutes.calls.scheduled },
                ]}
            >
            </PageHeader>
            <FacilitatorScheduledCalls />
        </Fragment>
    );
};

export default FacilitatorScheduledCallsWrapper;
